import { utc } from '@date-fns/utc'
import classNames from 'classnames'
import { parseISO } from 'date-fns'
import { toZonedTime, format } from 'date-fns-tz'
import { type VFC } from 'react'
import { baseStyle } from './styles'

type ScheduledTimeProps = {
  caps?: boolean
  className?: string
  color?: string
  dateFormat?: string
  fontSize?: number
  timestamp?: string
  timezone?: string
}

export const ScheduledTime: VFC<ScheduledTimeProps> = ({
  caps,
  className,
  color,
  dateFormat = '',
  fontSize,
  timestamp,
  timezone = 'America/Los_Angeles',
}) => {
  const validTimezone = timezone || 'America/Los_Angeles'
  let date = 'Not scheduled yet'

  if (timestamp) {
    const utcTime = parseISO(timestamp, { in: utc })
    const timezoneTime = toZonedTime(utcTime, validTimezone)
    date = format(timezoneTime, dateFormat, { timeZone: validTimezone })
  }

  return (
    <time
      css={baseStyle({ caps, color, fontSize })}
      className={classNames('periodic-scheduled-time', className, {
        'is-empty': !timestamp,
      })}
      dateTime={timestamp}
      role="time"
    >
      {date}
    </time>
  )
}
